import { CorrectionInboundItemSearchContent } from './correction-item-search-content';
import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { ItemsContext_VariantsPackFieldsFragment } from '@/types';
import { StyleSheet, View } from 'react-native';
import { VariantPackOrderCountsMap } from './types';

interface Props {
  alternativeMatches: ItemsContext_VariantsPackFieldsFragment[];
  headerMessage: string;
  onClose: () => void;
  onItemCorrectionCallback: (metadata: ItemListOptionMetadata) => Promise<void>;
  previousMatches: ItemsContext_VariantsPackFieldsFragment[];
  savedVariantPackOrderCountsMap: VariantPackOrderCountsMap;
  substitutionsMatches: ItemsContext_VariantsPackFieldsFragment[];
  variantPackUUID: string;
}

export const CorrectionItemInlinePanel: React.FC<Props> = ({
  alternativeMatches,
  headerMessage,
  onClose,
  onItemCorrectionCallback,
  previousMatches,
  savedVariantPackOrderCountsMap,
  substitutionsMatches,
  variantPackUUID,
}) => {
  return (
    <View
      style={styles.inlineCorrectionItemContainer}
      testID="correction-item-inline-panel"
    >
      <CorrectionInboundItemSearchContent
        alternativeMatches={alternativeMatches}
        headerMessage={headerMessage}
        onClose={onClose}
        onItemCorrection={onItemCorrectionCallback}
        previousMatches={previousMatches}
        savedVariantPackOrderCountsMap={savedVariantPackOrderCountsMap}
        substitutionsMatches={substitutionsMatches}
        variantPackUUID={variantPackUUID}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inlineCorrectionItemContainer: {
    flex: 1,
  },
});
